"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressFieldLogic = void 0;
var address_fieldtype_1 = require("./address.fieldtype");
Object.defineProperty(exports, "AddressFieldLogic", { enumerable: true, get: function () { return address_fieldtype_1.AddressFieldLogic; } });
